export const SET_CRUDTABLE = 'SET_CRUDTABLE';
export const SET_TABLEAPI = 'SET_TABLEAPI';
export const SET_SCHEMENAME = 'SET_SCHEMENAME';